import { Group, Skeleton, Stack } from '@mantine/core';

import { useIsMobile } from '~/domains/common/hooks/mediaQueries';

type SectionSkeletonProps = {
  currentSectionKey?: string;
};

export function SectionSkeleton({ currentSectionKey }: SectionSkeletonProps) {
  const isMobile = useIsMobile();

  const tileHeight = 75;

  if (currentSectionKey === 'finalStep') {
    return <Skeleton h={48} />;
  }

  if (currentSectionKey === 'init') {
    return (
      <Stack spacing="xl" pt="md" mb="md">
        <Stack spacing="md">
          <Skeleton h={isMobile ? 18 : 22} w="60%" />
          <Group noWrap spacing="xs">
            <Skeleton h={100} radius="md" />
            <Skeleton h={100} radius="md" />
            <Skeleton h={100} radius="md" />
            <Skeleton h={100} radius="md" />
          </Group>
        </Stack>

        <Stack spacing="md">
          <Skeleton h={isMobile ? 18 : 22} w="40%" />
          <Group noWrap spacing="xs">
            <Skeleton h={80} radius="md" />
            <Skeleton h={80} radius="md" />
            <Skeleton h={80} radius="md" />
          </Group>
        </Stack>
      </Stack>
    );
  }

  return (
    <Stack spacing="xl" pt="md" mb="md">
      <Stack spacing="xs">
        <Stack spacing="xs" mb="sm">
          <Skeleton h={isMobile ? 20 : 28} w="50%" />
          <Skeleton h={isMobile ? 20 : 22} w="30%" />
        </Stack>

        <Stack spacing="xs">
          <Group noWrap spacing="xs">
            <Skeleton h={tileHeight} />
            <Skeleton h={tileHeight} />
          </Group>
        </Stack>
      </Stack>
    </Stack>
  );
}
